export enum FilterFieldsKeys {
  ChainName = "chain_name",
  Currency = "currency",
  WalletAddress = "wallet_address",
}

export type FilterFields = {
  [FilterFieldsKeys.ChainName]: string;
  [FilterFieldsKeys.Currency]: string;
  [FilterFieldsKeys.WalletAddress]: string;
};
